<p-dialog [(visible)]="isVisible" [header]="helpItem?.title" (onHide)="close()">
  <div [innerHTML]="sanitizedContent"></div>
</p-dialog>
